import { useNavigate, useLocation } from 'react-router-dom'
import { useEffect, useRef, useState } from 'react'
import { InputX, Input, Select, InputRed, Toast, Button, InputTimer } from 'components'
import styles from './index.module.css'
import Lib from 'library'
import useAuth from 'hooks/useAuth'
import useApp from 'hooks/useApp'
import useStateWithValidation from 'hooks/useStateWithValidation'

const DormantCheck = ({ reset }) => {

	//#region Variables
	const App = useApp()
	const Auth = useAuth()
	const location = useLocation()
	const navigate = useNavigate()
	const mounted = useRef()

	const [buttonDisabled, setButtonDisabled] = useState(true) // 메인버튼 disabled 여부
	const [selectDisabled, setSelectDisabled] = useState(false) // 셀렉트 dsiabled 여부
	const [inputsDisabled, setInputsDisabled] = useState(false) // 인풋들 disabled 여부

	const [telecom, setTelecom] = useState(App.personal.telCom) // 통신사
	const [telNum, setTelNum, isValidTelNum] = useStateWithValidation(pn => pn.length === 0 || /\d{10,11}/.test(pn), App.personal.phoneNum ?? "") // 전화번호
	const [userName, setUserName, isValidUserName] = useStateWithValidation(name => name.length === 0 || /^[가-힣]+$/.test(name), App.personal.userName ?? "") // 이름
	// const [socialNum1, setSocialNum1] = useState(App.personal.socialNum1 ?? "") // 주민번호 앞자리
	const [socialNum1, setSocialNum1, isValidSocialNum1] = useStateWithValidation(num1 => num1.length === 0 || (num1.length === 6 && !(/\D/.test(num1))), App.personal.socialNum1 ?? "") // 주민번호 앞자리
	const [socialNum2, setSocialNum2, isValidSocialNum2] = useStateWithValidation(num2 => num2.length === 0 || !(/\D/.test(num2)), App.personal.socialNum2 ?? "") // 주민번호 뒤 1자리
	const [certNumber, setCertNumber] = useState("")
	const [telecomList, setTelecomList] = useState()

	// warnings
	const [certRed, setCertRed] = useState(false)  // 인증 오류 경고 필드
	const [certRedText, setCertRedText] = useState("숫자 6자리로 입력해 주세요.") // 인증 오류 경고 문구

	const [showToast, setShowToast] = useState(false) // 토스트 보이기/가리기
	const [toastText, setToastText] = useState() // 토스트 문구

	const [certTimout] = useState(180) // 인증번호 입력 시간 제한
	const [timerStart, setTimerStart] = useState(false) // 타이머 스타트 여부
	const [sent, setSent] = useState(App.data.sent) // 인증요청 여부
	const [mbIdChk, setMbIdChk] = useState(window.localStorage.getItem("mbId")) // 인증요청 여부

	const certBlock = useRef() // 인증번호 입력 div
	const telComSelect = useRef() // 통신사 선택 select
	const certInput = useRef() // 인증번호 입력 input
	//#endregion

	//#region Variants
	const variants = {
		initial: {
			x: "100vw"
		},
		animate: {
			x: 0
		},
		exit: {
			x: "-100vw"
		}
	}
	//#endregion

	//#region methods
	// 인증번호 입력 시간 초과
	const onTimerComplete = () => {
		// ShowToast("시간이 다 되었습니다.")
		setCertRedText("입력시간이 초과되었습니다. 인증번호를 재전송해주세요.")
		setCertRed(true)
		setCertNumber("")
		setButtonDisabled(true)
	}

	// 정보 검증
	const validate = () => {
		if (Lib.isNull(telecom)) return false

		if (Lib.isNull(telNum) || !(/^\d{10,11}$/.test(telNum))) return false

		if (Lib.isNull(userName) || /[^가-힣]|^$/.test(userName)) return false

		if (Lib.isNull(socialNum1) || /\D/.test(socialNum1) || socialNum1.length < 6) return false

		// if ((Lib.isNull(socialNum2) || /\D/.test(socialNum2) || (/[^1234]/.test(socialNum2))) || socialNum2 === "") return false
		if ((Lib.isNull(socialNum2) || /\D/.test(socialNum2)) || socialNum2 === "") return false

		return true
	}

	// 모든 input disabled 하기/풀기
	const disableAllInputs = (t = true) => {
		setInputsDisabled(t)
		setSelectDisabled(t)
	}

	// 인증번호 요청, 확인
	const onButton = () => {
		// 20221006 인증인 안되는 경우로 인해 잠시 주석처리 gwchoi onButton
        console.log(Lib.isAdult(socialNum1));

		switch (Lib.isAdult(socialNum1)) {
			case undefined:
				ShowToast("잘못된 주민번호입니다.")
				break;
			case false:
				navigate("/underage")
				break;
			default:
				if (sent) {
					// 인증성공이면 다음페이지로

					let url
					url = `/api/mb/login/verify/drmnc`
					Lib.post(url, {
						authNo: certNumber
					}, res => {
						App.alert("휴대폰 본인인증을 완료하였습니다.", () => {
							navigate("/home")
						})
					}, error => {
                        App.showAlert({
                            msg: `${error.code}: ${error.msg}`,
                            onOk: () => {
                                setCertNumber("")
                                certInput.current.focus()
                            }
                        })
                        console.log(error)
                    })
				} else {
					// 인증번호 발송 요청
					sendCertNumber()
				}
				break;
		}
	}

	const onPhoneNumChange = e => {
		let value = e.target.value
		App.personal.phoneNum = value
		setTelNum(value)
	}

	const onUserNameChange = e => {
		let value
		if (!e) { value = "" } else { value = e.target.value }
		App.personal.userName = value
		setUserName(value)
	}

	const onUserSocial1Change = e => {
		let value
		if (!e) { value = "" } else { value = e.target.value }
		App.personal.socialNum1 = value
		setSocialNum1(value)
	}

	const onUserSocial2Change = e => {
		let value
		if (!e) { value = "" } else { value = e.target.value }
		App.personal.socialNum2 = value
		setSocialNum2(value)
	}

	const onCertChange = e => {
		setCertNumber(e.target.value ?? "")
	}

	const ShowToast = (text) => {
		setToastText(text)
		setShowToast(true)
	}

	// disabled 된 인풋 클릭시
	const onInputClick = () => {
		if (!inputsDisabled) return false
		App.showAlert({
			msg: "입력하신 정보를 수정하시겠습니까?",
			confirm: true,
			onOk: () => {
				disableAllInputs(false)
				setSent(false)
				showCertBlock(false)
				setCertNumber("")
				setButtonDisabled(!validate())
			}
		})
	}

	// 인증번호 재전송
	const onResetClick = e => {
		sendCertNumber()
		setCertRed(false)
	}

	// 결과 코드 받기
	const getResultCode = (code) => {
		let text
		switch (code) {
			case "0000":
				text = "인증 성공"
				break
			case "0001":
				text = "인증 불일치(통신사선택오류, 생년월일/성명/휴대폰번호 불일치, 휴대폰일시정지, 선불폰가입자, SMS발송실패, 인증문자불일치 등)"
				break
			case "0003":
				text = "기타인증오류"
				break
			case "0010":
				text = "인증번호 불일치(소켓)"
				break
			case "0012":
				text = "요청정보오류(입력값오류)"
				break
			case "0013":
				text = "암호화 시스템 오류"
				break
			case "0014":
				text = "암호화 처리 오류"
				break
			case "0015":
				text = "암호화 데이터 오류"
				break
			case "0016":
				text = "복호화 처리 오류"
				break
			case "0017":
				text = "복호화 데이터 오류"
				break
			case "0018":
				text = "통신오류"
				break
			case "0019":
				text = "데이터베이스 오류"
				break
			case "0020":
				text = "유효하지않은 CP코드"
				break
			case "0021":
				text = "중단된 CP코드"
				break
			case "0022":
				text = "휴대전화본인확인 사용불가 CP코드"
				break
			case "0023":
				text = "미등록 CP코드"
				break
			case "0031":
				text = "유효한 인증이력 없음"
				break
			case "0035":
				text = "기인증완료건(소켓)"
				break
			case "0040":
				text = "본인확인차단고객(통신사)"
				break
			case "0041":
				text = "인증문자발송차단고객(통신사)"
				break
			case "0050":
				text = "NICE 명의보호서비스 이용고객 차단"
				break
			case "0052":
				text = "부정사용차단"
				break
			case "0070":
				text = "간편인증앱 미설치"
				break
			case "0071":
				text = "앱인증 미완료"
				break
			case "0072":
				text = "간편인증 처리중 오류"
				break
			case "0073":
				text = "간편인증앱 미설치(LG U+ Only)"
				break
			case "0074":
				text = "간편인증앱 재설치필요"
				break
			case "0075":
				text = "간편인증사용불가-스마트폰아님"
				break
			case "0076":
				text = "간편인증앱 미설치"
				break
			case "0078":
				text = "14세 미만 인증 오류"
				break
			case "0079":
				text = "간편인증 시스템 오류"
				break
			case "9097":
				text = "인증번호 3회 불일치"
				break
			default:
				text = "기타오류"
				break
		}
		return text
	}

	// 인증번호 발송하기
	const sendCertNumber = () => {
		let url
		if (reset) {
			url = `/api/mb/login/verify/drmncReq`
		} else {
			url = `/api/mb/login/verify/drmncReq`
		}
		Lib.post({
			url: url,
			data: {
				cphNo: telNum,
				nm: userName,
				rsdtRegNo: `${socialNum1}${socialNum2}`,
				tcomCd: telecom
			},
			onSuccess: res => {
                console.log(res);
                if (res.code === "S000") {
                    disableAllInputs(true)
                    ShowToast("인증번호가 발송되었습니다.")
                    showCertBlock(true)
                    setCertNumber("")
                    certInput.current.focus()
                    setTimerStart(true)
                    setSent(true)
                    setButtonDisabled(true)
                } else if (res.code === "E112") {
                    App.showAlert("회원정보와 일치하지 않는 정보에요. <br/> 휴대폰 번호 변경, 개명 등으로 인해 로그인이 불가능한 경우 고객센터로 연락 주세요.")
                } else {
                    App.showAlert(`${res.code}: ${res.msg}`)
                }
			},
			onError: error => {
				App.showAlert(`${error}`)
			}
		})
	}

	// 인증번호 입력 보이기/가리기
	const showCertBlock = (t = true) => {
		if (t) {
			certBlock.current.style.display = "block"
		} else {
			certBlock.current.style.display = "none"
		}
	}

	// 통신사 목록 가져오기
	const getTelecomList = async () => {
		const list = await Lib.getCommonCode("TCOM")
		if (!list) {
			setTelecomList([
				{
					key: "SKT",
					value: "SKT"
				},
				{
					key: "KT",
					value: "KT"
				},
				{
					key: "LGU+",
					value: "LGT"
				},
				{
					key: "SKT 알뜰폰",
					value: "SKM"
				},
				{
					key: "KT 알뜰폰",
					value: "KTM"
				},
				{
					key: "LGU+ 알뜰폰",
					value: "LGM"
				},
			])
		} else {
			setTelecomList(list.map(item => {
				return {
					key: item.commNm,
					value: item.commCd
				}
			}))
		}
	}
	//#endregion

	//#region useEffect
	useEffect(() => {
		if (Lib.isNull(telecom)) {
			telComSelect.current.show()
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [telecomList])

	useEffect(() => {
		setCertRedText("숫자 6자리로 입력해 주세요.")
		const max = Number(certInput.current.getAttribute("maxlength"))
		const regexp = new RegExp(`^\\d{${max}}$`)
		if (regexp.test(certNumber)) {
			setButtonDisabled(false)
			setCertRed(false)
		} else {
			setButtonDisabled(true)
			setCertRed(true)
		}
	}, [certNumber])

	useEffect(() => {
		setSent(false)
	}, [location.pathname])

	useEffect(() => {
		App.data.sent = true

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [sent])

	useEffect(() => {
		setButtonDisabled(!validate())

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [telecom, telNum, userName, socialNum1, socialNum2])

	useEffect(() => {
		if (!sent && validate()) {
			// 20221006 인증인 안되는 경우로 인해 잠시 주석처리 gwchoi 
			onButton();
			// sendCertNumber()
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [socialNum2])

	const goLogin = () => {
		Auth.setIsLogin(false)
		navigate('/')
	}

	useEffect(() => {
		mounted.current = true

		App.setShowNav(false)
		App.setMainClass("white")
		App.setHeader({
			show: true,
			title: " ",
			left: <i className="icon_arrow_back" onClick={() => goLogin()} />,
			right: null
		})

		setMbIdChk(window.localStorage.getItem("mbId"))

		mounted.current && getTelecomList()

		console.log(document.forms)

		return () => {
			mounted.current = false
			setShowToast()
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])
	//#endregion

	return (
		<div className="page">
			{/* <motion.div className="page" variants={variants} initial="initial" animate="animate" exit="exit"> */}
			<div className="padding flex_1">
                <h3>반갑습니다!</h3>
                <h3>휴대폰 본인 인증을 진행해주세요.</h3>

				<p className="guide-title mt_40" style={{ color: "black" }}>휴대폰 번호</p>
				{/* <div className="flex" onClick={onInputClick}>
					<Select ref={telComSelect} disabled={selectDisabled} name="telCom" className={`mr_10 ${styles.basis1}`} placeholder="통신사선택" title="통신사를 선택해주세요." selected={App.personal.telCom} data={telecomList} onSelect={(key, value) => {
						App.personal.telCom = value
						setTelCom(value)
						validate()
						document.querySelector("[name='phoneNum']").focus()
					}}>
					</Select>
					<InputX onClick={onInputClick} disabled={inputsDisabled} name="phoneNum" type="tel" value={phoneNum} placeholder="휴대폰번호 입력" className={styles.basis2} maxlength="11" onChange={onPhoneNumChange} next="[name='userName']" onX={() => setPhoneNum("")} />
				</div>
                 */}
                 <div className="flex-align_center mt_10">
					<Select ref={telComSelect} disabled={selectDisabled} placeholder="선택" title="통신사" style={{ width: "12rem" }} selected={telecom} data={telecomList} onSelect={(key, value) => {
						setTelecom(value)
					}}>
					</Select>
					<InputX onClick={onInputClick} disabled={inputsDisabled} name="telNum" tabindex="4" type="tel" placeholder="휴대폰 번호 입력" defaultValue={telNum} next="[name='userName']" setValue={setTelNum} className="flex--item_1 ml_20" maxlength="11" onChange={e => {
						setTelNum(e.target.value)
					}} onX={() => setTelNum("")}/>
				</div>
				<InputRed text="숫자 10~11자로 입력해주세요." show={!isValidTelNum} />

				<p className="guide-title mt_40" style={{ color: "black" }}>이름</p>
				<div onClick={onInputClick}>
					<InputX onClick={onInputClick} className="mt_10" disabled={inputsDisabled} value={userName} name="userName" placeholder="이름 입력" onChange={onUserNameChange}  onX={() => setUserName("")} />
				</div>
				<InputRed text="한글로만 입력해주세요." show={!isValidUserName} />

                {/* <p className="guide-title mt_40">주민등록번호</p>
						<div className="flex-align_center mt_10" style={{ position: "relative" }}>
							<InputX name="socialNum1" tabindex="2" type="tel" placeholder="주민번호 앞 6자리" defaultValue={socialNum1} setValue={setSocialNum1} className="flex_1" maxlength="6" onChange={e => {
								setSocialNum1(e.target.value)
							}} onKeyPress={e => {
								if (e.which === 13) {
									socialNum2.current.focus()
								}
							}} />
							<span style={{ margin: "0 0.5rem" }}>-</span>
							<div className="flex--item_1">
								<Input tabindex="3" type="tel" style={{ width: "3rem", paddingRight: 0, textAlign: "center" }} maxlength="1" onChange={e => {
									setSocialNum2(e.target.value)
								}} />
								<div className="floating-dots">
									<span />
									<span />
									<span />
									<span />
									<span />
									<span />
								</div>
							</div>
						</div> */}

                <p className="guide-title mt_40" style={{ color: "black" }}>주민등록번호</p>
                <div className="flex-align_center mt_10" onClick={onInputClick} style={{ position: "relative" }}>
                    <InputX value={socialNum1} name="socialNum1" type="tel" placeholder="주민번호 앞 6자리" className="flex_1" onClick={onInputClick} onChange={onUserSocial1Change} 
                        disabled={inputsDisabled} maxlength="6" next="[name='socialNum2']" onX={() => setSocialNum1("")} />
                    <span style={{ margin: "0 0.5rem" }}>-</span>
               
                    <div className="flex--item_1">
                        <Input type="tel" style={{ width: "3rem", paddingRight: 0, textAlign: "center" }} value={socialNum2} onClick={onInputClick} onChange={onUserSocial2Change} 
                            disabled={inputsDisabled} name="socialNum2" className="text-align_center"  maxlength="1" />
                        <span className="floating-dots">
                            <span />
                            <span />
                            <span />
                            <span />
                            <span />
                            <span />
                        </span>
                    </div>
                </div>

				<InputRed text="입력한 정보를 확인해주세요." show={!isValidSocialNum1 || !isValidSocialNum2} />

				<div ref={certBlock} className={`${styles.certBlock} mt_60`}>
					<p className="guide-title mt_40" style={{ color: "black" }}>인증번호</p>
					<div className="mt_10 relative flex-align_center">
						<Input ref={certInput} type="tel" name="certInput" className="flex_1 mr_15" maxlength="6" onChange={onCertChange} value={certNumber} />
						<Button className="btn btn--sm btn--light-blue nowrap" style={{ fontSize: "1.2rem" }} onClick={onResetClick}>재전송</Button>
						<InputTimer start={timerStart} setStart={setTimerStart} duration={certTimout} onComplete={onTimerComplete} />
					</div>
					<InputRed text={certRedText} show={certRed} />
				</div>

			</div>
			<div className="padding flex-shrink_0">
				<Button id="button" className="btn btn--big" onClick={onButton} disabled={buttonDisabled}>{sent ? "다음" : "인증요청"}</Button>
			</div>
			<Toast show={showToast} setShow={setShowToast} text={toastText} />
		</div>
	)
}

export default DormantCheck
